module.exports = __webpack_public_path__ + "assets/img/img83.0848b25c.png";